import theme from './default/theme';

export default theme;
